import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaVideoPlaybackSyncAutoplayDisplay,
  useMediaVideoPlaybackSyncDisplay,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';
import {useWorkspaceMediaSettingsActions} from '../contexts/MediaWorkspaceSettingsContextProvider';

export const VideoPlaybackSyncAutoplay = () => {
  const {settingsLevel, panelRef} = useMediaSettingsContext();
  const isEnabledVideoPlaybackSync = useMediaVideoPlaybackSyncDisplay(
    settingsLevel,
    panelRef
  );
  const isEnabledAutoPlay = useMediaVideoPlaybackSyncAutoplayDisplay(
    settingsLevel,
    panelRef
  );
  const {
    updateConfig: updateWorkspaceConfig,
    unsetConfigField: unsetWorkspaceConfigField,
  } = useWorkspaceMediaSettingsActions();

  const [shouldSyncVideoPlaybackAutoplay, setShouldSyncVideoPlaybackAutoplay] =
    useState(isEnabledAutoPlay);

  if (!isEnabledVideoPlaybackSync) {
    return null;
  }
  return (
    <div className={'flex justify-between gap-24'}>
      <SettingTitle
        title="Autoplay videos"
        description="Automatically start playing videos when entering the workspace or opening a panel."
        configField="videoPlaybackSyncAutoplay"
      />
      <Switch.Root
        aria-label="Toggle video playback autoplay"
        data-test="sync-video-playback-autoplay-switch"
        checked={shouldSyncVideoPlaybackAutoplay}
        onCheckedChange={newValue => {
          setShouldSyncVideoPlaybackAutoplay(newValue);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            if (newValue) {
              updateWorkspaceConfig({videoPlaybackSyncAutoplay: newValue});
            } else {
              unsetWorkspaceConfigField('videoPlaybackSyncAutoplay');
            }
          }, 100);
        }}>
        <Switch.Thumb checked={shouldSyncVideoPlaybackAutoplay ?? false} />
      </Switch.Root>
    </div>
  );
};
